import { ModuleAction } from "@app/enums/role";

export enum ModuleStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  MAINTENANCE = "MAINTENANCE",
}

export interface Module {
  id: number;
  name: string;
  title?: string;
  icon: string;
  route?: null | string;
  preview?: null | Record<string, any>;
  status: ModuleStatusEnum;
  order: number;
  parent_id: number | null;
  permissions: string[];
  items?: Module[];
  isPowerBi?: boolean;
  pivot?: PivotRoleOfModule;
  action?: ModuleAction;
  type?: string;
  description?: string;
  icon_color?: string;
  powerBiCard?: ImageCardMenu;
  submodulesCard?: ImageCardMenu;
  smallSubmodulesCard?: ImageCardMenu;
}

export interface ImageCardMenu {
  backgroundImage?: string;
  colorTextImage?: string;
}

interface ModuleResponse {
  module: Module;
}

export interface PivotRoleOfModule {
  modulable_id: number;
  module_id: number;
  modulable_type: string;
  created_at: string;
  updated_at: string;
  id: number;
  permissions: string[];
  active: number;
  order: number;
  featured?: boolean;
  background_card_url?: string;
}

export interface ModuleDataResponse {
  data: ModuleResponse;
}
